import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Shared 3D "raised" treatment used across the dashboard (navbar, sidebar,
// action buttons): top highlight + soft float at rest, lifts on hover,
// presses in on click. Pair with a surface (border + bg).
export const btn3d = cn(
  "transition-all duration-200 ease-out will-change-transform",
  "shadow-[inset_0_1px_0_rgba(255,255,255,0.12),0_1px_2px_rgba(0,0,0,0.14),0_4px_8px_-3px_rgba(0,0,0,0.28)]",
  "hover:-translate-y-0.5 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.18),0_2px_4px_rgba(0,0,0,0.16),0_10px_16px_-5px_rgba(0,0,0,0.42)]",
  "active:translate-y-0 active:shadow-[inset_0_2px_5px_rgba(0,0,0,0.28),0_1px_2px_rgba(0,0,0,0.16)]"
)

// The `difficulty` column holds both encodings — `E`/`M`/`H` from one set of
// import scripts and `Easy`/`Medium`/`Hard` from another — so any UI that
// compares against a spelled-out label must normalize first, or it silently
// treats every letter-encoded row as unknown.
const DIFFICULTY_LABELS: Record<string, "Easy" | "Medium" | "Hard"> = {
  e: "Easy",
  easy: "Easy",
  m: "Medium",
  medium: "Medium",
  h: "Hard",
  hard: "Hard",
}

export function normalizeDifficulty(
  value?: string | null
): "Easy" | "Medium" | "Hard" | null {
  if (!value) return null
  return DIFFICULTY_LABELS[value.toLowerCase().trim()] ?? null
}
